/* eslint-disable react/require-default-props */
import React from 'react';
import { HStack } from '@chakra-ui/core';
import { LocationFilter } from './LocationFilter';
import { StatusFilter } from './StatusFilter';
import { PositionFilter } from './PositionFilter';

export interface Filters {
  locations: string[];
  status: string[];
  positions: string[];
  selectAllLocations: boolean;
  selectAllStatus: boolean;
  selectAllPositions: boolean;
}

const defaultFilter: Filters = {
  locations: [],
  selectAllLocations: true,
  status: [],
  selectAllStatus: true,
  positions: [],
  selectAllPositions: true,
};

interface CandidateFilterProps {
  filters: Filters;
  onChange: (filters: Filters) => void;
  isFetching?: boolean;
}

export const CandidateFilter = React.memo(function CandidateFilter({ filters, onChange, isFetching }: CandidateFilterProps) {
  const handleChange = React.useCallback(
    <K extends keyof Filters>(
      field: K,
      value: Filters[K],
      selectAll: Partial<Record<'selectAllLocations' | 'selectAllStatus' | 'selectAllPositions', boolean>>,
    ) => {
      onChange({ ...defaultFilter, ...filters, [field]: value, ...selectAll });
    },
    [filters, onChange],
  );

  return (
    <HStack>
      <StatusFilter
        values={filters.status}
        isSelectAll={filters.selectAllStatus}
        onChange={(status, selectAll) => {
          handleChange('status', status, { selectAllStatus: selectAll ?? false });
        }}
        isDisabled={isFetching}
      />
      <LocationFilter
        values={filters.locations}
        isSelectAll={filters.selectAllLocations}
        onChange={(locations, selectAll) => {
          handleChange('locations', locations, { selectAllLocations: selectAll ?? false });
        }}
        isDisabled={isFetching}
      />
      <PositionFilter
        values={filters.positions}
        isSelectAll={filters.selectAllPositions}
        onChange={(positions, selectAll) => {
          handleChange('positions', positions, { selectAllPositions: selectAll ?? false });
        }}
        isDisabled={isFetching}
      />
    </HStack>
  );
});
